var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"//fonts.googleapis.com/css?family=Roboto:400,500,700,400italic|Material+Icons"}}),_c('vue-particles',{attrs:{"color":"#fe4231"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }